import { render, staticRenderFns } from "./ajustements-aim.vue?vue&type=template&id=5a735a17&ref=ajustementVue"
import script from "./ajustements-aim.vue?vue&type=script&setup=true&lang=js"
export * from "./ajustements-aim.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ajustements-aim.vue?vue&type=style&index=0&id=5a735a17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports